/**
 * External dependencies
 */
import { combineReducers } from 'redux';

/**
 * Internal dependencies
 */
import { SECTION_SET } from "./action-types";
import route from './route/reducer';
import modal from './modal/reducer';


export function hasSidebar( state = true, action ) {
    switch ( action.type ) {
        case SECTION_SET:
            return action.hasSidebar !== undefined ? action.hasSidebar : state;
        default:
            return state;
    }
}


export function section( state = false, action ) {
	switch ( action.type ) {
		case SECTION_SET:
			return action.section !== undefined ? action.section : state;
        default:
            return state;
	}
}

export function isLoading( state = false, action ) {
	switch ( action.type ) {
		case SECTION_SET:
			return action.isLoading !== undefined ? action.isLoading : state;
        default:
            return state;
	}
}



const reducer = combineReducers({
    hasSidebar,
    route,
    section,
    modal,
    isLoading
});

export default reducer;